import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numbersOnly]',
})
export class NumberOnlyDirective {
  @Input() isAllowPlus: boolean = false;

  constructor(private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Enter', 'Tab', 'ArrowRight', 'ArrowLeft', 'Delete'];
    if (allowedKeys.indexOf(event.key) !== -1 ||
      // Allow: Ctrl+A
      (event.key === 'a' && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+C
      (event.key === 'c' && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+V
      (event.key === 'v' && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+X
      (event.key === 'x' && (event.ctrlKey || event.metaKey))) 
    {
      return;
    }
    if ((!this.isAllowPlus && (event.key < '0' || event.key > '9')) || (this.isAllowPlus && (event.key < '0' || event.key > '9') && event.key !== '+' )) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.limitInputToSixDigits(event.target);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const pastedText = clipboardData.getData('text/plain');
      const onlyDigits = this.isAllowPlus ? pastedText.replace(/[^0-9+]/g, '') : pastedText.replace(/[^0-9*]/g, '').replace(/[^\w\s]/g, '');
      this.limitInputToSixDigits(event.target, onlyDigits);
      event.preventDefault();
    }
  }
  private limitInputToSixDigits(input: HTMLInputElement, value: string = '') {
    const inputValue = value || input.value;
    input.value = inputValue.substring(0, input['maxLength']).replace(this.isAllowPlus ? /[^0-9+]+/g : /[^0-9*]*/g, '');
    this.updateModelValue(input.value);
  }

  private updateModelValue(newValue: string) {
    if (this.control) {
      const control = this.control.control;
      control?.setValue(newValue);
    }
  }

}
